export const payrollEntryNumericalFields = [
    "EmployeePayRate",
    "CommissionThreshold",
    "Salary",
    "DefaultSalary",
    "ContractorPayment",
    "RegularHours",
    "OvertimeHours",
    "DoubleTimeHours",
    "TotalHoursWorked",
    "ExtraHoursWorked",
    "RegularRate",
    "OvertimeRate",
    "DoubleTimeRate",
    "RegularAmount",
    "OvertimeAmount",
    "DoubleTimeAmount",
    "OvertimePremiumRate",
    "OvertimePremiumAmount",
    "DoubleTimePremiumRate",
    "DoubleTimePremiumAmount",
    "DeductedGuaranteedWages",
    "TotalGuaranteed",
    "RegularCommission",
    "WorkOrderPayoutAmount",
    "ManualCommissionAmount",
    "SubtotalCommission",
    "TotalCommissionAmount",
    "CommissionBonus",
    "DiscretionaryBonus",
    "CellAllowance",
    "Tip",
    "TravelAllowance",
    "SickPay",
    "SplitTime",
    "ReportingTime",
    "MealPeriodPremiumTime",
    "HolidayPay",
    "SplitTimeAmount",
    "SickPayAmount",
    "MealPeriodPremiumAmount",
    "ReportingTimeAmount",
    "Chargeback",
    "TrainingPay",
    "TrainingPayHours",
    "MinimumWageAdvance",
    "TotalCommissionAndBonus",
    "GrossPay",
    "NetPayAddition",
    "NetPayDeduction",
    "WageAdvanceDifferentialRate",
];
